import { BANK_DEFINITION_TYPES } from '../types';

export const getAddressObj = (bankName: string, fullAddress: string) => {
  const splitBankAddress = fullAddress.split(',');
  return {
    addressLine: `${splitBankAddress?.[0]}${bankName === BANK_DEFINITION_TYPES.SUNRISE ? '' : `, ${splitBankAddress?.[1]}` || ''}`,
    stateAndZip: bankName === BANK_DEFINITION_TYPES.SUNRISE ? `${splitBankAddress?.[1]}, ${splitBankAddress?.[2] || ''}` : `${splitBankAddress?.[2]}, ${splitBankAddress?.[3] || ''}`,
  };
};
